import { h, } from "@stencil/core";
import { isBreakpointEqualOrSmaller } from "../../../utils";
import { FocusTrapHelper } from "../../../utils/functions/focusTrapHelper";
import { setScrollLock } from "../../../utils/functions/scrollLock";
export class DcUiHeaderLanguage {
    constructor() {
        this.isMobile = false;
        this.isOpen = false;
        this.updateIsMobile = () => {
            this.isMobile = isBreakpointEqualOrSmaller('xl');
        };
        this.iconClickHandler = () => {
            this.dcFlyoutClose.emit(this.el);
            this.close();
        };
    }
    onOutsideClick(e) {
        if (!this.isOpen)
            return;
        // Get the full path of elements including through shadow DOM boundaries
        const path = e.composedPath();
        // Check if our element is in the path
        if (!path.includes(this.el) && this.isOpen) {
            this.close();
        }
    }
    onKeyDown(e) {
        if (!this.isOpen)
            return;
        if (e.key === 'Escape') {
            this.close();
        }
    }
    // method to open the modal
    async open() {
        setScrollLock(true);
        this.dialog.show();
        setTimeout(() => {
            this.isOpen = true;
        }, 100);
        this.focusTrapHelper.activateFocusTrap();
    }
    // method to close the modal
    async close() {
        if (!this.isMobile) {
            setScrollLock(false);
        }
        this.dialog.close();
        setTimeout(() => {
            this.isOpen = false;
        }, 100);
        this.focusTrapHelper.deactivateFocusTrap();
    }
    async toggle() {
        if (this.dialog.open) {
            this.close();
        }
        else {
            this.open();
        }
    }
    componentDidLoad() {
        this.updateIsMobile();
        window.addEventListener('resize', this.updateIsMobile);
        this.focusTrapHelper = new FocusTrapHelper(this.el);
    }
    disconnectedCallback() {
        window.removeEventListener('resize', this.updateIsMobile);
    }
    render() {
        const backButton = (h("button", { key: '9e4dd3187171961dfbed7800e37d069acb173571', class: "back-button", onClick: this.iconClickHandler }, h("dc-ui-icon", { key: '32c5fdb61aca1bd22aac50b715fe56813343a9c1', size: "tiny", name: "dc_backward_left" }), this.backButtonLabel));
        const closeButton = (h("dc-ui-button", { key: 'e7a15e7f53a656271c7d6fd607e9461eafd9db29', class: "close-button", variant: "link", icon: "dc_close", hideLabel: true, id: "close-icon", size: "small", onClick: this.iconClickHandler }, "Close Modal"));
        return (h("dialog", { key: 'b7392f9bbd4df0ed3366ed84fd83c4a4cb6e7a9a', class: "language-dialog", ref: (el) => (this.dialog = el) }, h("div", { key: '03759fbcd30286bfdc1fca2eb190851989dfb70f', class: "dialog-body" }, h("div", { key: '5f1ec55e733e8f4747bdcc9f7bf6e2a0be2ca2d4', class: "dialog-content" }, h("div", { key: '4589b07a0abd895b0f64f2b79a4434443fb3da76', class: "title-wrapper" }, this.headline && (h("dc-ui-text", { key: 'ee7996f5469ea9c999262b9114e3aaa177a70ff0', variant: "h3", color: "darkBlue02" }, this.headline))), h("div", { key: 'dae57ad72303acdc67672bc31eb580768ab17ec8', class: "content-wrapper" }, h("slot", { key: 'f865cfc77f158e9f319e9fe71d4c1eff42ae3282' })), this.isMobile ? (this.backButtonLabel ? backButton : closeButton) : closeButton))));
    }
    static get is() { return "dc-ui-header-language"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["dc-ui-header-language.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dc-ui-header-language.css"]
        };
    }
    static get properties() {
        return {
            "headline": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "headline",
                "reflect": false
            },
            "backButtonLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "back-button-label",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "isMobile": {}
        };
    }
    static get events() {
        return [{
                "method": "dcFlyoutClose",
                "name": "dcFlyoutClose",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "HTMLDcUiHeaderLanguageElement",
                    "resolved": "HTMLDcUiHeaderLanguageElement",
                    "references": {
                        "HTMLDcUiHeaderLanguageElement": {
                            "location": "global",
                            "id": "global::HTMLDcUiHeaderLanguageElement"
                        }
                    }
                }
            }];
    }
    static get methods() {
        return {
            "open": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            },
            "close": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            },
            "toggle": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "click",
                "method": "onOutsideClick",
                "target": "window",
                "capture": false,
                "passive": false
            }, {
                "name": "keydown",
                "method": "onKeyDown",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=dc-ui-header-language.js.map
